import { callZigzagFunction } from '../../callZigzagFunction';
import { zigzagHandler } from '../../handlers';

// GIF 이미지 멈추기 여부 확인 요청 (리턴값은 `onIsOffGif` 참조)
export const ciog = () => {
  return new Promise<boolean>(resolve => {
    callZigzagFunction('ciog')();
    zigzagHandler('onIsOffGif', isOffGif => {
      resolve(isOffGif);
    });
  });
};
